export async function storeProductData() {
  try {
    let response = await fetch("/collections/all?sections=productmap");
    let data = await response.json();
    const myArray = data.productmap.split("|||");
    let g = myArray[1].replace(/,\s*$/, "").trim();
    let ff = JSON.parse(g);
    const newProducts = ff.products;

    // Retrieve existing products from localStorage
    const existingProducts = JSON.parse(localStorage.getItem('products')) || {};

    // Update existingProducts with newProducts
    for (const [key, newProduct] of Object.entries(newProducts)) {
      if (existingProducts[key]) {
        // If the product already exists, update it but preserve item_list_id and item_list_name
        const { item_list_id, item_list_name } = existingProducts[key];
        existingProducts[key] = { ...newProduct, item_list_id, item_list_name };
      } else {
        // Add the new product as it doesn't exist
        existingProducts[key] = newProduct;
      }
    }

    // Store the updated existing products back to localStorage
    localStorage.setItem('products', JSON.stringify(existingProducts));

  } catch (error) {
    console.error("Error:", error);
  }
}